import { render } from "./authorEdit.vue?vue&type=template&id=705d47f0"
import script from "./authorEdit.vue?vue&type=script&lang=js"
export * from "./authorEdit.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__